import React from "react";
import "../../css/ParticipantCard.css";
import Insurance from "./Insurance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Toggle from "./Toggle";

const ParticipantCard = ({ isMain, data, showNNWInsurance, onChange, onInsuranceChange }) => {
  return (
  <div className={`participant-card ${isMain ? "main-participant" : ""}`}>
    <div className="participant-header">
    <FontAwesomeIcon icon={faUserCircle} className="participant-icon" />
      <input
        type="text"
        placeholder="Imię i nazwisko"
        value={data.preferredName || ''}
        onChange={(e) => onChange("preferredName", e.target.value)}
        className="preferred-name-input"
        required
      />
    </div>
    <div className="participant-body">
      <label>Email</label>
      <input
        type="email"
        placeholder="Podaj e-mail"
        value={data.email}
        onChange={(e) => onChange("email", e.target.value)}
        required={!isMain}
        disabled={isMain}
      />

      <label>Telefon</label>
      <input
        type="tel"
        placeholder="Podaj numer telefonu"
        value={data.phone}
        onChange={(e) => onChange("phone", e.target.value)}
        required={!isMain}
        disabled={isMain}
        pattern="^\+?[0-9 ]{9,15}$"
        title="Numer telefonu musi mieć od 9 do 15 cyfr i może zaczynać się od +."
      />

      <label>Twoje zaimki:</label>
      <input
        type="text"
        placeholder="Twoje zaimki"
        value={data.pronouns}
        onChange={(e) => onChange("pronouns", e.target.value)}
        title="Podaj Twoje zaimki."
      />

        <div className="toggleLabel">
          <span style={{ marginTop: "5px" }}>To moja pierwsza wycieczka</span>
          <label className="toggleSwitch">
            <input
              type="checkbox"
              className="toggleInput"
              checked={data.firstTime}
              onChange={(e) => onChange("firstTime", e.target.checked)}
            />
            <span className="toggleSlider"></span>
          </label>
      </div>

<div>
<div className={`highlightedToggleBox ${data.isAdult ? "validToggle" : "invalidToggle"}`}>
  <div className="toggleLabel">
    <span>Osoba pełnoletnia *</span>
    <label className="toggleSwitch">
      <input
        type="checkbox"
        className="toggleInput"
        checked={data.isAdult}
        onChange={(e) => onChange("isAdult", e.target.checked)}
      />
      <span className="toggleSlider"></span>
    </label>
  </div>
  <div className="toggleHint">
Udział w wydarzeniach możliwy jest wyłącznie dla osób pełnoletnich. Zaznaczając tę opcję, oświadczasz, że powyższa osoba ukończyła 18 rok życia najpóźniej w dniu rozpoczęcia wydarzenia.
  </div>
</div>


</div>

    </div>
    {showNNWInsurance && <Insurance
      data={data.insurance}
      onChange={onInsuranceChange} />
    }
  </div>
);
}

export default ParticipantCard;
